<template>
  <div class="cooperation">
    <section class="banner">
      <div class="coop-img">
        <p>奥创合作商火热招募中</p>
        <p>畅享红利，共赢万亿企业服务蓝海市场</p>
      </div>
      <div class="coop-img-phone">
        <p class="title" >合作伙伴</p>
        <p class="title-info" >一起为企业提供更专业及时的服务与解决方案</p>
      </div>
    </section>
    <div class="main">
      <section class="support">
        <h3>奥创能为您提供的支持</h3>
        <ul class="wrap-title">
          <li>
            <div class="support-item" @click="toggleSupports(0)"  :class="{active: supportIndex === 0}">
              <img src="../../assets/cooperation/support1-active.png" v-if="supportIndex == 0">
              <img src="../../assets/cooperation/support1.png" v-else>
              <span class="support-text">定制服务</span>
            </div>
          </li>
          <li></li>
          <li>
            <div class="support-item"  @click="toggleSupports(1)" :class="{active: supportIndex === 1}">
              <img src="../../assets/cooperation/support3-active.png" v-if="supportIndex == 1">
              <img src="../../assets/cooperation/support3.png" v-else>
              <span class="support-text">渠道合作</span>
            </div>
          </li>
          <li></li>
          <li>
            <div class="support-item"  @click="toggleSupports(2)"  :class="{active: supportIndex === 2}">
              <img src="../../assets/cooperation/support2-active.png" v-if="supportIndex == 2">
              <img src="../../assets/cooperation/support2.png" v-else>
              <!--<img :src="supportIndex === 2 ? '/src/assets/cooperation/support2-active.png' : '/src/assets/cooperation/support2.png'" width="58" height="58" alt="">-->
              <span class="support-text">CRM对接</span>
            </div>
          </li>
        </ul>
        <div class="wrap">
          <!-- screenWidth-->
          <ul class="out-ul" :style="{width: screenWidth >= 1200 ? supportList.length * 1200 + 'px': supportList.length * screenWidth + 'px', transform:  screenWidth >= 1200 ? 'translateX(-'+supportIndex * 1200 +'px)' : 'translateX(-'+supportIndex * screenWidth +'px)',transition: 'all .5s ease-in',}">
            <li class="out-li" v-for="item in supportList" :key="item.id" :style="{width: screenWidth >= 1200 ? 1200 + 'px' : screenWidth + 'px'}">
              <div class="source-coope">
                <div class="coop-left">
                  <div class="title">{{item.title}}</div>
                  <ul>
                    <li v-for="tip in item.items" :key="tip"><i>· </i>{{tip}}</li>
                  </ul>
                </div>
                <div class="coop-right">
                  <img :src="item.bgImg" alt="" style="width: 100%; height: 100%;">
                </div>
              </div>
            </li>
          </ul>
        </div>
      </section>
      <section class="all-round">
        <h3>产品、培训、运营、资源全方位赋能 <br> 助力伙伴持续快速成长</h3>
        <ul class="alive">
          <li class="all-round-item">
            <img src="../../assets/cooperation/product-support.png" alt="">
            <h5>产品支持</h5>
            <p>总部根据市场需求产品迭代创新速度快，通过一次次快速迭代，使产品赢得用户的广泛青睐，帮助代理商牢牢抓住客户资源。</p>
          </li>
          <li class="all-round-item">
            <img src="../../assets/cooperation/train-support.png" alt="">
            <h5>培训支持</h5>
            <p>总部会定期针对代理商人员的需求开展进行产品、销售、售后、管理等相关培训，快速提高代理商团队的战斗力，帮助代理商打造核心竞争力。</p>
          </li>
          <li class="all-round-item">
            <img src="../../assets/cooperation/adver-support.png" alt="">
            <h5>广告支持</h5>
            <p>总部定期或者不定期的会根据代理商的情况给予物料支持，如：展会宣传物料、UI设计等，利于代理商在当地开展业务。</p>
          </li>
          <li class="all-round-item">
            <img src="../../assets/cooperation/source-support.png" alt="">
            <h5>资源支持</h5>
            <p>奥创总部会不定期的在线上或线下进行市场推广活动扩大知名度与影响力，获得资源部分转接给代理商，代理商无需承担推广费用。</p>
          </li>
          <li class="all-round-item">
            <div class="big-item">
              <h5>技术支持</h5>
              <p>奥创总部提供7×12小时在线技术服务， 保障问题高效、快速的解决，让代理商、客户没有后顾之忧。</p>
            </div>
          </li>
        </ul>
      </section>
      <section class="coop-process">
        <h3>合作流程</h3>
        <ul>
          <li>
            <div class="half-width">
              <div class="index">01</div>
              <div class="content">
                <p>请联系客服或认真 <strong>填写</strong> 申请 <strong>表单</strong>，确保资料真实性，确认合作意向</p>
              </div>
            </div>
            <div class="border-limit"></div>
          </li>
          <li>
            <div class="half-width">
              <div class="index">02</div>
              <div class="content">
                <p><strong>奥创</strong> 完成 <strong>审核</strong> 后将由客服通知或以其他形式告知</p>
              </div>
            </div>
            <div class="border-limit"></div>
          </li>
          <li>
            <div class="half-width">
              <div class="index">03</div>
              <div class="content special-content">
               <p>审核通过后，具体了解相关事宜，之后 <strong>签署</strong> 合作 <strong>协议</strong></p>
              </div>
            </div>
            <div class="border-limit"></div>
          </li>
          <li>
            <div class="half-width">
              <div class="index">04</div>
              <div class="content">
                <p><strong>支付</strong> 所需 <strong>保证金</strong>，经财务确认即完成缴纳</p>
              </div>
            </div>
            <div class="border-limit"></div>
          </li>
          <li>
            <div class="half-width">
              <div class="index">05</div>
              <div class="content">
                <p>奥创软件研究院 <strong>进行部署</strong>，并提供各项支持</p>
              </div>
            </div>
            <div class="border-limit"></div>
          </li>
          <li>
            <div class="half-width">
              <div class="index">06</div>
              <div class="content">
                <p>助力企业 <strong>变现</strong> 客户 <strong>资源</strong></p>
              </div>
            </div>
            <div class="border-limit"></div>
          </li>
        </ul>
      </section>
    </div>
    <section class="apply-try">
      <div class="form">
        <h3>立即申请  成为合作伙伴</h3>
        <div class="form-item">
          <div class="form-tip">
            <label for="applyName">您的姓名</label>
            <input type="text" v-model="username" autocomplete="off" id="applyName">
          </div>
          <div class="form-tip phone">
            <label class="phone-text" for="phone"> 联系电话</label>
            <input class="phone-value" v-model="phoneNumber" type="text" autocomplete="off" id="phone">
          </div>
        </div>
        <div class="form-item">
          <div class="form-tip">
            <label for="company-name">公司名称</label>
            <input type="text" v-model="companyName" autocomplete="off" id="company-name">
          </div>
          <div class="form-tip verify-code">
            <label for="note">验证码</label>
            <input class="verify-value" v-model="verifyCode" type="text" autocomplete="off" placeholder="请先获取验证码" id="verify">
            <span class="verify-text" @click="getVerify" >获取验证码</span>
          </div>
        </div>
        <div class="form-item note">
          <div class="form-tip">
            <label for="note"> 留言</label>
            <input type="text" v-model="autocomplete" autocomplete="off" id="note">
          </div>
        </div>
        <div class="submit-wrap">
          <span class="error-text" :class="promptMessage.type" >{{promptMessage.value}}</span>
          <button class="btn" @click="submitApply">立即申请</button>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import Index from './main'

export default {
  name: 'cooperation',
  ...Index
}
</script>
<style lang="scss" scoped>
  @import './index';
</style>
